// Fixes Slick's swipeToSlide traversal for centerMode + variableWidth sliders.
//
// Slick's built-in getSlideCount() measures the drag position against the
// list's LEFT edge, but centered sliders are translated by half the viewport
// width — so multi-slide sweeps undercount by ~2 slides and the slider
// visibly rewinds after release. Replace the measurement with "the slide
// whose center is nearest the viewport center at the release point".
export default function fixCenterModeSwipe($slider) {
	const slick = $slider.slick("getSlick");

	slick.getSlideCount = function () {
		const _ = this;

		if (_.options.swipeToSlide !== true) {
			return _.options.slidesToScroll;
		}

		const viewportCenter = -_.swipeLeft + _.listWidth / 2;
		let nearest = null;
		let nearestDist = Infinity;

		_.$slideTrack.find(".slick-slide").each(function (i, slide) {
			const slideCenter = slide.offsetLeft + $(slide).outerWidth() / 2;
			const dist = Math.abs(slideCenter - viewportCenter);
			if (dist < nearestDist) {
				nearestDist = dist;
				nearest = slide;
			}
		});

		return Math.abs($(nearest).attr("data-slick-index") - _.currentSlide) || 1;
	};

	// Slick clamps backward swipe targets at -1 via checkNavigable(), so a
	// multi-slide backward sweep near the start of the loop lands back on
	// slide 0 — a hard rewind. With slidesToScroll: 1 every index is
	// navigable and slideHandler() already wraps negatives, so pass the
	// index through untouched.
	const originalCheckNavigable = slick.checkNavigable.bind(slick);
	slick.checkNavigable = function (index) {
		const _ = this;
		if (_.options.infinite === true && _.options.slidesToScroll === 1) {
			return index;
		}
		return originalCheckNavigable(index);
	};
}
